import React, { useEffect } from "react";

function GoogleTranslateWidget() {
  useEffect(() => {
    window.googleTranslateElementInit = function () {
      if (window.google && window.google.translate) {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            autoDisplay: false,
          },
          "google_translate_element",
        );
      }
    };

    const existingScript = document.getElementById("google-translate-script");

    if (!existingScript) {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    } else if (window.google && window.google.translate) {
      window.googleTranslateElementInit();
    }

    return () => {
      delete window.googleTranslateElementInit;
    };
  }, []);

  return (
    <div className="google-translate-wrapper">
      <div id="google_translate_element" className="google-translate-element" />
    </div>
  );
}

export default GoogleTranslateWidget;
